import React from "react";
import { CollectionPreferences } from "@amzn/awsui-components-react-v3";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../../../common/redux/store/store";
import { UPDATE_HISTORICAL_QTY_CONSUMPTION_PREFERENCES } from "../../../../../../../common/redux/types/consumptionPreferenceTypes";

const CONTENT_DISPLAY_OPTIONS = [
    {
        label: 'Primary columns',
        options: [
            {id: "sfgName", label: "Supersets & Logical Groups", editable: false},
            {id: "supplierId", label: "Supplier Code"},
            {id: "manufacturer", label: "Manufacturer"},
            {id: "quantityConsumed", label: "Consumed Quantity"},
        ]
    }
]

export const HISTORICAL_QTY_CONSUMPTION_DEFAULT_PREFERENCES = {
    stickyColumns: {first: 0, last: 0},
    visibleContent: ['sfgName', 'supplierId', 'manufacturer', 'quantityConsumed']
};

export const HistoricalQtyConsumptionPreferences = ({disabled, visibleContentOptions = CONTENT_DISPLAY_OPTIONS}) => {
    const dispatch = useDispatch<AppDispatch>();
    const {historicalQtyConsumptionPreference} = useSelector((state: RootState) => state.consumptionPreferenceDetails);
    return (
        <CollectionPreferences
            title="Preferences"
            confirmLabel="Confirm"
            cancelLabel="Cancel"
            disabled={disabled}
            onConfirm={({detail}) => dispatch({type: UPDATE_HISTORICAL_QTY_CONSUMPTION_PREFERENCES, payload: detail})}
            preferences={historicalQtyConsumptionPreference}
            visibleContentPreference={{
                title: 'Column Preferences',
                options: visibleContentOptions,
            }}
            stickyColumnsPreference={{
                firstColumns: {
                    title: "Stick first column(s)",
                    description:
                        "Keep the first column(s) visible while horizontally scrolling the table content.",
                    options: [
                        { label: "None", value: 0 },
                        { label: "First column", value: 1 },
                        { label: "First two columns", value: 2 }
                    ]
                },
                lastColumns: {
                    title: "Stick last column",
                    description:
                        "Keep the last column visible while horizontally scrolling the table content.",
                    options: [
                        { label: "None", value: 0 },
                        { label: "Last column", value: 1 }
                    ]
                }
            }}
        />
    );
}